module.exports = __webpack_public_path__ + "static/media/11.9404cf33.jpg";